import { useHistory, useLocation } from "react-router-dom";
import { useTransactions } from "./use-transactions";

export function useTransactionDrawer() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const { data: transaction, ...rest } = useTransactions({
    select: (data) =>
      data.find(
        (transaction) =>
          transaction.transaction_id === queryParams.get("transaction")
      ),
    enabled: queryParams.has("transaction"),
  });

  const handleOpen = (id) => {
    if (!isRestrictedRoute(location.pathname)) {
      if (queryParams.has("transaction")) {
        queryParams.delete("transaction");
      }

      queryParams.set("transaction", id);
      history.push({
        search: queryParams.toString(),
      });
    }
  };

  const handleClose = () => {
    if (!isRestrictedRoute(location.pathname)) {
      if (queryParams.has("transaction")) {
        queryParams.delete("transaction");
        history.replace({
          search: queryParams.toString(),
        });
      }
    }
  };

  const isRestrictedRoute = (pathname) => {
    return pathname === "/signup" || pathname === "/login";
  };

  return {
    transaction,
    open:
      queryParams.has("transaction") && !isRestrictedRoute(location.pathname),
    drawerData: transaction,
    handleClose,
    handleOpen,
    ...rest,
  };
}
